import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import api from "../../../../../services/api";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import useWorkshopProgressStore from "../../../stores/workshopProgressStore";

export const AppContext = React.createContext({});

export default function Context({ children, workshopId }) {
  const [workshop, setWorkshop] = useState(null);
  const [userWorkshop, setUserWorkshop] = useState(null);
  const user = useSelector((state) => state.Auth.user);
  const { progress, setProgress } = useWorkshopProgressStore();
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const index = parseInt(searchParams.get("index")) || 0;
  const [mode, setMode] = useState("normal");
  const [unsaved, setUnsaved] = useState(false);

  // Preserve pathId and courseId across navigation
  const pathId = searchParams.get("pathId") || "";
  const courseId = searchParams.get("courseId") || "";

  function setIndex(i) {
    const params = new URLSearchParams();
    params.set("index", i);
    if (pathId) params.set("pathId", pathId);
    if (courseId) params.set("courseId", courseId);
    navigate(`${pathname}?${params.toString()}`);
  }

  async function fetchWorkshop() {
    const { data } = await api.get(`/workshop/${workshopId}`);
    setWorkshop(data);
    if (user) {
      const { data: Wu } = await api.get(`/workshop_user/${workshopId}`);
      setUserWorkshop(Wu);
    } else {
      const saved = progress[workshopId];
      if (saved) setUserWorkshop(saved);
    }
  }

  useEffect(() => {
    fetchWorkshop();
  }, [workshopId]);

  async function next() {
    const obj = {};
    const totalSteps = workshop.steps.length + 1;

    const newIndex = index + 1;

    const finished = newIndex >= totalSteps;

    if (userWorkshop && user) {
      if (!userWorkshop.finished_at && finished) {
        obj.finished_at = Date.now();
      }

      if (!userWorkshop?.step_id || userWorkshop.step_id <= newIndex) {
        obj.step_id = newIndex;
        if (index === totalSteps) obj.step_id = totalSteps;
      }
      const { data: uw } = await api.put(`/workshop_user/${userWorkshop._id}`, obj);
      setUserWorkshop(uw);
    } else if (!user) {
      const progress = { ...(userWorkshop || {}), step_id: newIndex, finished_at: finished ? Date.now() : userWorkshop?.finished_at };
      setProgress(workshopId, progress);
      setUserWorkshop(progress);
    }

    if (finished) {
      toast.success("Workshop finished!");
    }
    setIndex(newIndex);
  }

  const setValues = (v) => {};

  async function updateUserWorkshop() {
    if (!userWorkshop) return;
    if (!user) {
      setProgress(workshopId, { ...userWorkshop });
      return;
    }
    const { data } = await api.put(`/workshop_user/${userWorkshop._id}`, { questions: userWorkshop.questions });
    setUserWorkshop(data);
  }

  return (
    <AppContext.Provider
      value={{
        index,
        setIndex,
        workshop,
        setWorkshop,
        next,
        unsaved,
        setValues,
        userWorkshop,
        setUserWorkshop,
        updateUserWorkshop,
        setMode,
        mode,
        pathId,
        courseId,
        user,
      }}>
      {children}
    </AppContext.Provider>
  );
}
